import { format, isToday, isTomorrow, parseISO } from "date-fns";
import { de } from "date-fns/locale";
import { SLOT_CONFIG, slotToInternalId } from "./timeSlots";

/**
 * Format a time slot string to a human-readable German label.
 */
export function formatTimeSlot(slot: string): string {
  try {
    return SLOT_CONFIG[slotToInternalId(slot)].label;
  } catch {
    return slot; // unknown/legacy strings fall back to raw value
  }
}

/**
 * Format a date string relative to today (Heute/Morgen/EEE, d. MMM).
 */
export function formatDateRelative(dateStr: string): string {
  const date = parseISO(dateStr);
  if (isToday(date)) return "Heute";
  if (isTomorrow(date)) return "Morgen";
  return format(date, "EEE, d. MMM", { locale: de });
}

/**
 * Short slot label for compact views (VM/NM/Sa).
 */
export function formatSlotLabel(slot: string): string {
  try {
    return SLOT_CONFIG[slotToInternalId(slot)].shortLabel;
  } catch {
    return slot;
  }
}

/**
 * Get a human-readable label for a service type.
 */
export function getServiceLabel(type: string): string {
  return type === "schnuppertag" ? "Schnuppertag" : "Regeltermin";
}
